// extracted by mini-css-extract-plugin
module.exports = {"select":"CustomSelect_select__2JhmT","error-message":"CustomSelect_error-message__1S-RY"};